import { render } from "./DisassociateButtonRenderer.vue?vue&type=template&id=710b0384"
import script from "./DisassociateButtonRenderer.vue?vue&type=script&lang=js"
export * from "./DisassociateButtonRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__